import React from 'react';

import {useTranslation} from "react-i18next";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingButton from "@mui/lab/LoadingButton";

type ConfirmDialogProps = {
    open: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
    content: string;
    title: string;
    disabled?: boolean;
    loading?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, handleClose, handleConfirm, content, title,
                                                         disabled = false, loading = false}) => {
    const {t} = useTranslation('common');

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <LoadingButton onClick={handleConfirm} loading={loading} disabled={disabled}>{t("confirm")}</LoadingButton>
                <LoadingButton onClick={handleClose} loading={loading} autoFocus color="inherit" disabled={disabled}>{t("cancel")}</LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;